module.exports = __webpack_public_path__ + "media/images/emblems/Armoiries_Enfers-292bb609b583daa6dc126e589c501849.png";